
import { Component, Mixins, Prop } from "vue-property-decorator";
import {
	mdiPencil,
	mdiAccountArrowRightOutline,
} from "@mdi/js";
import { role } from "../../pipes";
import ContextMenu from "../ui/ContextMenu.vue";
import { MyTeamsMixin, VuetifyMixin, BAIconsMixin } from "../../mixins";
import { ContextMenuItem, InviteStaffFormValue } from "@/../types/interfaces";
import { EditTeam } from "@/../types/constants/web_client_user.routes";
import { teamCreateStore, userStore, notificationStore } from "@/store";
import { NotificationModel } from '@/models/notification/NotificationModel';
import { StaffMember } from '@/models/team/StaffMember';
import { InvitationStatus } from '@/../types/enums';
import InviteStaffDialog from '@/components/teams/InviteStaffDialog.vue';
import TeamRecord from './TeamRecord.vue';

@Component({
	components: { ContextMenu, InviteStaffDialog },
})
export default class TeamDetailsCard extends Mixins(VuetifyMixin, BAIconsMixin, MyTeamsMixin, TeamRecord) {
	roleToStr = role;

	@Prop({ type: Boolean }) loading: boolean;
	@Prop({ type: Boolean }) readOnly: boolean;
	@Prop({ type: Boolean }) nomenu: boolean;
	showConfirmLeaveTeam: boolean = false;
	showInviteDialog: boolean = false;
	staffInviteId: string = "";
	staffInvite: StaffMember = null;

	coachInviteForm: InviteStaffFormValue = {
		firstName: "",
		lastName: "",
		email: "",
		role: undefined,
	};

	inviteCoach(staff: StaffMember){
		this.staffInviteId = staff.id;
		this.coachInviteForm = {
			firstName: staff.firstName,
			lastName: staff.lastName,
			email: staff.email,
			role: staff.role,
		};
		this.staffInvite = staff;
		this.showInviteDialog = true;
	}

	CoachInvitationPending(staff: StaffMember): boolean {
		if (staff.coachId) return false
		return staff.invitationStatus === InvitationStatus.Pending && userStore.coachId !== staff.coachId;
	}

	isCoachInvited(staff: StaffMember): boolean{
		return staff.invitationStatus === InvitationStatus.None;
	}

	didCoachAccept(staff: StaffMember): boolean{
		return !!staff.coachId || staff.invitationStatus === InvitationStatus.Accepted
	}

	get showInviteOrResend(): boolean {
		return this.staffInvite && !this.staffInvite.coachId && this.staffInvite.invitationStatus === InvitationStatus.None;
	}

	get AthleteMenuItems(): ContextMenuItem[]{
		return [
			{
				icon: mdiAccountArrowRightOutline,
				text: "Leave Team",
				click: () => this.showLeaveTeamBox(),}
		]
	}

	get CoachMenuItems(): ContextMenuItem[] {
		return [
			{
				icon: mdiPencil,
				text: "Edit Team",
				click: () => {
					this.$router.push({
						name: EditTeam,
						params: {
							teamId: this.team.id
						}
					});
				}
			},
			{
				icon: mdiAccountArrowRightOutline,
				text: "Leave Team",
				click: () => this.showLeaveTeamBox()
			}
			// {
			// 	icon: mdiEmailOpen,
			// 	text: "Invite New Staff"
			// },
			// {
			// 	icon: mdiMagnify,
			// 	text: "Find players"
			// },
			// {
			// 	icon: mdiArrowLeft,
			// 	text: "Leave team"
			// },
		];
	}
	async leaveTeam(): Promise<void> {
		this.showConfirmLeaveTeam = false;
		await teamCreateStore.leaveTeam({ teamId: this.team.id });
		await notificationStore.pushSnackbarSuccess(new NotificationModel(`You have left ${this.team.name}!`));
		this.$router.push({
			path: '/'
		});
	}
	showLeaveTeamBox(): void {
		this.showConfirmLeaveTeam = true;
	}

	cancelLeaveTeam(): void {
		this.showConfirmLeaveTeam = false;
	}
}
